import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[shield-clicks]',
  standalone: true
})
export class ShieldClicksDirective implements OnInit {
  @Input('shield-clicks') shieldClicks: any = true;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    const nativeElement = this.el.nativeElement;
    // execute if there is no boolean specified or the boolean is true
    if (this.shieldClicks === '' || this.shieldClicks === true || this.shieldClicks === 'true') {
      const shield = this.renderer.createElement('a');
      this.renderer.addClass(shield, 'clickShield');
      this.renderer.setAttribute(shield, 'href', 'javascript:void(0)');

      const parent = nativeElement.parentNode;
      if (parent) {
        this.renderer.insertBefore(parent, shield, nativeElement);

        const interactionHandler = () => {
          if (!nativeElement.innerHTML.trim()) {
            this.renderer.removeChild(parent, shield);
          }
        };

        shield.addEventListener('mouseover', interactionHandler, { once: true });
        shield.addEventListener('click', interactionHandler, { once: true });
        shield.addEventListener('touchstart', interactionHandler, { once: true });
      }
    }
  }
}
